import React, { useState } from "react";
import { BoxButton, CDialog, Icon } from "shared";
import { InviteBillingAdminForm } from "./InviteBillingAdminForm";
import { Send } from "assets";
import { useTranslation } from "react-i18next";

export const InviteBillingAdmin: React.VFC = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  return (
    <>
      <BoxButton startIcon={<Icon of={Send} />} onClick={openDialog}>
        {t("form.invite_billing_admin")}
      </BoxButton>

      <CDialog maxWidth="xs" fullWidth open={isOpen} onClose={closeDialog} aria-labelledby="invite-billing-admin">
        <InviteBillingAdminForm onClose={closeDialog} />
      </CDialog>
    </>
  );
};
